import { withCatalogLayout } from "@/elements-react/catalog-layout/withCatalogLayout";
import { usePaymentTermCommon } from "@/pages-react/payment-terms-page/PaymentTermcCommon.tsx";
import { LayoutStyleTypes } from "@/util-react/layout.tsx";

export const PaymentTermsMobile = withCatalogLayout((props: { content: string }) => {
  const { renderContent } = usePaymentTermCommon(props.content);

  return (
    <>
      {renderContent()}
    </>
  );
}, LayoutStyleTypes.TYPE_SM);
